import {EventEmitter, InjectionToken, Provider} from '@angular/core';
// import {gettext} from 'i18n-plugin';

export const ERROR_COLLECTOR_SOURCE = new InjectionToken<ErrorCollection>('ERROR_COLLECTOR_SOURCE');

export function errorCollectionSourceFactory(): ErrorCollection {
  return new ErrorCollection();
}

export const errorCollectionSourceProvider: Provider = {
    provide: ERROR_COLLECTOR_SOURCE,
    useFactory: errorCollectionSourceFactory,
};

export interface IErrorCollectionError  {
    readonly status?: string;
    readonly message: string;
}

export class ErrorCollectionError implements IErrorCollectionError {

    public readonly message: string;
    public readonly status?: string;

    constructor(
        $message: string,
        $status?: string
    ) {
        this.message = $message; // gettext($message);
        this.status = $status;
    }
}

export class ErrorCollection {

    private _errors: ReadonlyArray<IErrorCollectionError> = [];

    // public title: string;
    public onChange = new EventEmitter<void>();

    public addError($error: IErrorCollectionError): void {
        if (this._errors.indexOf($error) < 0) {
            this._errors = this._errors.concat($error);
            this.onChange.emit();
        }
    }

    public removeError($error: IErrorCollectionError): void {
        const index = this._errors.indexOf($error);
        if (index > -1) {
            this._errors = this._errors.slice(0, index).concat(this._errors.slice(index + 1));
            this.onChange.emit();
        }
    }

    public clear(): void {
        this._errors = [];
        this.onChange.emit();
    }

    public get errors(): ReadonlyArray<IErrorCollectionError> { return this._errors; }
}
